import React from 'react';
import { styled } from '@linaria/react';

const Link = styled.a`
  color: var(--bb-link-color);
  text-decoration: none;
  line-height: normal;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: var(--bb-link-color--hover);
  }

  svg {
    width: 12px;
    height: 12px;

    path {
      fill: var(--bb-link-color);
    }
  }
`;

export default ({ children, ...rest }) => <Link {...rest}>{children}</Link>;
